import Layout from "../../../components/layout";
import Breadcrumb from "../../../components/breadcrumbs";
import { useEffect, useState } from "react";
import { getPages } from "../../privacyPolicy/api";
import MarkdownIt from "markdown-it";
import aboutbnr from "../../../assets/images/aboutbnr.png";
import logo from "../../../assets/images/basin_logo.png";
import phn from "../../../assets/images/phn.png";
import googleplay from "../../../assets/images/googleplay.svg";
import appstore from "../../../assets/images/appstore.svg";

const AboutUs = () => {
  const [aboutPage, setAboutPage] = useState<string>("");

  const mdParser = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
  });

  useEffect(() => {
    getPages({ type: 4 }).then((res) => {
      setAboutPage(res.data.data.content);
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <meta
        name="description"
        content="Learn about Commbitz, a leader in eSIM solutions. Connecting travelers in over 190+ countries with reliable, affordable, and seamless digital roaming."
      />
      <title>About Commbitz | Simplifying Global Connectivity</title>
      <Breadcrumb />
      {/* <div className="newabout">
        <div className="container">
         
        </div>
      </div> */}
      <div className="container about-content">
        <div className="row align-items-center mt-5">
          <div className="col-md-6">
            <h3>About Commbitz eSIM & Buyticket.in</h3>
            {/* <div
              className="text-dark mb-5"
              dangerouslySetInnerHTML={{ __html: mdParser.render(aboutPage) }}
              
            /> */}
            Commbitz eSIM and Buyticket.in are two leading platforms that have joined forces to revolutionize the way you travel. We understand that a truly seamless journey requires both effortless connectivity and convenient access to the experiences that matter. Our partnership combines the best of both worlds, providing a one-stop solution for the modern traveler.

            <h3>Our Mission</h3>
            Our shared mission is to simplify and enhance your travel experience. Commbitz eSIM is dedicated to providing instant, global connectivity through cutting-edge eSIM technology. We eliminate the hassle of physical SIM cards and expensive roaming fees, ensuring you stay connected from the moment you land. Buyticket.in complements this by offering a user-friendly platform for all your booking needs, from flights and hotels to local attractions and events. Together, we empower you to focus on your journey, not the logistics.

            <h3>Why We're a Perfect Match</h3>
            The synergy between Commbitz eSIM and Buyticket.in is rooted in our commitment to convenience and value. When you plan your trip with Buyticket.in, you can seamlessly add a Commbitz eSIM to your travel itinerary, ensuring you're connected and ready to go as soon as you arrive.

            <ul>
              <li><span style={{ fontSize: "1.2em", fontWeight: "bold" }}>•</span><b> Effortless Connectivity:</b> With Commbitz eSIM, you get global data coverage in over 190+ countries, activated with a simple QR code scan.</li>
              <li><span style={{ fontSize: "1.2em", fontWeight: "bold" }}>•</span><b> Convenient Bookings:</b> Buyticket.in offers a wide range of travel-related services, making it easy to book flights, hotels, and experiences all in one place.</li>
              <li><span style={{ fontSize: "1.2em", fontWeight: "bold" }}>•</span><b> Integrated Solutions:</b> Our combined platform provides a unified experience, from booking your trip to securing your data plan, all designed to save you time and effort.</li>
            </ul>

            We are dedicated to providing you with the tools you need to explore the world freely and confidently. Whether you're a frequent business traveler, a digital nomad, or on a leisure trip, Commbitz eSIM and Buyticket.in are your trusted partners for a smarter, more connected journey.

          </div>

          <div className="col-md-6">
            <div className="newaboutbanner">
              <img src={aboutbnr} alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="phnApp">
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <div className="phnappleft">
                <img src={logo} alt="" />
                <h5 className="mt-4">
                  Stay Connected, Stay Free With Commbitz, you’re not just
                  getting an eSIM—you’re unlocking a world of effortless
                  connectivity. Travel anywhere, anytime, without worrying about
                  staying online
                </h5>
                <div className="aboutapp">
                  <p>
                    Download the Commbitz app today on the App Store or Google
                    Play, and experience the future of global connectivity!
                  </p>
                  <div className="appbtn">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.commbitz"
                      target="_blank"
                    >
                      <img src={googleplay} alt="" />
                    </a>
                    <a
                      href="https://apps.apple.com/in/app/commbitz-e-sim/id6572300745"
                      target="_blank"
                    >
                      <img src={appstore} alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="phnappright">
                <img className="w-100" src={phn} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AboutUs;
